// extracted by mini-css-extract-plugin
export default {"profile-header":"ProfileHeader_profile-header__vXMDm","profile-header-ul":"ProfileHeader_profile-header-ul__Swgab","active":"ProfileHeader_active__WJ64P"};